import { mix } from 'polished';
import React, { useMemo } from 'react';
import { Percent } from '~/components';
import { theme } from '../../components/schedule';
import { GroupCell } from '../../components/schedule/cells';
import CellHeatmap from './CellHeatmap';
import convertScale from './convertScale';
import Tooltip from './Tooltip';

function TotalUtilizationCell({ cell }) {
  const { background, color, heatmap } = useMemo(() => {
    switch (cell.mode) {
      case 'header':
        return {
          background: theme.cell.total.background,
          color: !cell.project || !cell.utilizationCapacity ? theme.cell.empty.color : theme.cell.total.color,
        };

      case 'heatmap': {
        const ratio = cell.project / cell.utilizationCapacity || 0;

        let background;
        let color;
        let heatmap;

        if (!cell.project || !cell.utilizationCapacity) {
          background = theme.cell.empty.background;
          color = theme.cell.empty.color;
        } else if (ratio > 1) {
          background = theme.cell.filled.background;
          heatmap = mix(
            Math.min(convertScale(ratio, { min: 1, max: 1.25 }, { min: 0, max: 1 }), 1),
            theme.cell.heatmap.danger.dark,
            theme.cell.heatmap.danger.light,
          );
          color = theme.cell.filled.color;
        } else if (ratio > 0.5) {
          background = theme.cell.filled.background;
          heatmap = mix(ratio, theme.cell.heatmap.success.dark, theme.cell.heatmap.success.light);
          color = theme.cell.filled.color;
        } else {
          background = theme.cell.filled.background;
          heatmap = mix(
            Math.min(convertScale(ratio, { min: 0, max: 0.5 }, { min: 0, max: 1 }), 1),
            theme.cell.heatmap.danger.light,
            theme.cell.heatmap.danger.dark,
          );
          color = theme.cell.filled.color;
        }

        return {
          background,
          color,
          heatmap,
        };
      }

      case 'placeholder':
        return {
          background: theme.cell.empty.background,
          color: theme.cell.empty.color,
        };
    }
  }, [cell.mode, cell.project, cell.utilizationCapacity]);

  return (
    <GroupCell style={{ background, color }}>
      <Tooltip cell={cell}>
        {cell.utilizationCapacity ? (
          <Percent value={cell.totalUtilization} minimumFractionDigits={0} maximumFractionDigits={0} />
        ) : (
          '-'
        )}
        {cell.mode === 'heatmap' && <CellHeatmap style={{ background: heatmap }} />}
      </Tooltip>
    </GroupCell>
  );
}

export default React.memo(TotalUtilizationCell);
